"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParamValueFromUrl = exports.getCookieValueBasedOnName = exports.generateFbBrowserRandomId = void 0;
/**
 * Generating browser-specific ID. Method taken from FBs pixel script
 * @returns {string} generated browser-specific ID
 */
const generateFbBrowserRandomId = () => `${Math.round(2147483647 * Math.random())}`;
exports.generateFbBrowserRandomId = generateFbBrowserRandomId;
/**
 * Gets the cookie value based on name
 * @param {FbCookieType | TtCookieType} type FbCookieType or TtCookieType
 * @returns {string | undefined} if the cookie exists, returns string; otherwise, returns undefined
 */
const getCookieValueBasedOnName = (type) => {
    var _a;
    const cookies = document.cookie;
    return (_a = cookies
        .split("; ")
        .find((txt) => txt.startsWith(`_${type}=`))) === null || _a === void 0 ? void 0 : _a.split("=")[1];
};
exports.getCookieValueBasedOnName = getCookieValueBasedOnName;
/**
 * Gets the value of the required URL parameter
 * @returns {string | null} param value if available, null otherwise
 */
const getParamValueFromUrl = (queryParam) => new URL(location.href).searchParams.get(queryParam);
exports.getParamValueFromUrl = getParamValueFromUrl;
